import { motion } from "framer-motion";

/**
 * Line-by-line masked reveal, rendered as a semantic heading (default h1).
 *
 * Pass `lines` as an array of strings. Each line animates from below its mask.
 * The outer wrapper is a real H1/H2/... so crawlers see one proper heading per
 * page — fixing the SEO issue where styled divs were used as headings.
 */
export default function KineticLines({
  lines = [],
  delay = 0.2,
  className = "",
  lineClassName = "",
  as: Tag = "h1",
}) {
  const text = lines.join(" ");
  return (
    <Tag className={className} aria-label={text}>
      {lines.map((line, i) => (
        <span key={i} className="overflow-hidden block">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{
              duration: 1.05,
              ease: [0.22, 1, 0.36, 1],
              delay: delay + i * 0.14,
            }}
            className={`block will-change-transform ${lineClassName}`}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
